import * as React from 'react';
import * as ReactDOM from 'react-dom';

import TimeSale from '../src/TimeSale';
import InsurancePriceCalculator from '../src/PriceCalculator/InsurancePriceCalculator';
import JRWTicketPriceCalculator from '../src/PriceCalculator/JRWTicketPriceCalculator';
import {TWP} from '../src/CartIn/TWP';
import {JEP_T} from '../src/CartIn/JEP_T';
import {JEP_NN} from '../src/CartIn/JEP_NN';
import SnowItemPriceCalculator from '../src/PriceCalculator/SnowItemPriceCalculator';
import SnowItemPriceCalculatorNoDate from '../src/PriceCalculator/SnowItemPriceCalculatorNoDate';
import AlertSuccess from '../src/ShoppingCart/AlertSuccess';
import Inventory from '../src/ShoppingCart/Inventory';
import Cart from '../src/ShoppingCart/Cart';
import YadoCartButton from '../src/ShoppingCart/YadoCartButton';
import YadoCancellationPolicy from '../src/ShoppingCart/YadoCancellationPolicy';
import { snowItemMinDateTime, insuranceMinDateTime, ticketMinDateTime, ticketMaxDateTime } from '../src/PriceCalculator/helpers';
import { ICurrency, IDeadline } from '../src/ShoppingCart/types';
import LessonSearch from '../src/LessonSearch';
import AccessUI from '../src/AccessUI';
import * as localStorage from '../src/utils/localStorage';

// styled-componentが2重で読み込まれてしまうため、カートと同じバンドルファイルに配置
// WebpackerのアップグレードしてspritChunksを使用する必要がある。
import '../src/SnowSearch/mount';

document.addEventListener('turbolinks:load', () => {
  Array.from(document.querySelectorAll('.access-ui')).forEach(element => {
    const centerString = element.getAttribute('data-center');
    const target_id = element.getAttribute('data-target-id');
    const place_id = element.getAttribute('data-target-place-id');
    if (target_id && centerString) {
      const [lat, lng] = centerString.split(',');
      ReactDOM.render(
        <AccessUI targetPlace={{
          target_id,
          place_id,
          latitude: parseFloat(lat),
          longitude: parseFloat(lng) }}
        />,
        element as HTMLElement
      );
    }
  });

  Array.from(document.querySelectorAll('.js-time-sale')).forEach(element => {
    const triggerElementId = element.getAttribute('data-trigger-element-id');
    const trackingName = element.getAttribute('data-tracking-name');
    const discountAmount = element.getAttribute('data-discount-amount');
    const cutOffString = element.getAttribute('data-cut-off-string');
    const timeout = Number(element.getAttribute('data-timeout'));
    ReactDOM.render(
      <TimeSale
        triggerElementId={triggerElementId}
        trackingName={trackingName}
        discountAmount={discountAmount}
        cutOffString={cutOffString}
        timeout={isNaN(timeout) ? 1000 : timeout}
      />,
      element as HTMLElement
    );
  });

  Array.from(document.querySelectorAll('.js-insurance-price-calculator')).forEach(element => {
    const itemId = element.getAttribute('data-item-id');
    const itemName = element.getAttribute('data-item-name');
    const planString = element.getAttribute('data-insurance-all-plans');
    const resortString = element.getAttribute('data-resort');
    const localCurrency: ICurrency = JSON.parse(element.getAttribute('data-local-currency'));
    ReactDOM.render(
      <InsurancePriceCalculator
        itemId={itemId}
        itemName={itemName}
        insuranceAllPlans={JSON.parse(planString || '{}')}
        minDateTime={insuranceMinDateTime()}
        resort={JSON.parse(resortString || '{}')}
        localCurrency={localCurrency}
      />,
      element as HTMLElement
    );
  });

  /**
   * JRW
   * TODO: 上記js-ticket-price-calculatorと統合するか、上記を削除するか
   */
  Array.from(
    document.querySelectorAll('.js-jrw-ticket-price-calculator')
  ).forEach((element: HTMLDivElement) => {
    const ticketId = parseInt(element.getAttribute('data-ticket-id'));
    const name = element.getAttribute('data-ticket-name');
    const localCurrency: ICurrency = JSON.parse(element.getAttribute('data-local-currency'));
    /**
     * ここのplanは、app/decorators/ticket_item_decorator.rbで定義されているplanの型を持つ
     */
    const plans = JSON.parse(element.getAttribute('data-plans')).map(({planId, name, price: {adultPrice: adultSellingPrice, childPrice: childSellingPrice}, ticketId}) => ({planId, name, adultSellingPrice, childSellingPrice, ticketId}));
    ReactDOM.render(<JRWTicketPriceCalculator plans={plans} ticket={{ticketId, name}} />, element);
  });

  Array.from(
    document.querySelectorAll('.js-twp-ticket-form')
  ).forEach((element: HTMLDivElement) => {
    const ticket = {
      ticketId: parseInt(element.getAttribute('data-ticket-id')),
      name: element.getAttribute('data-name'),
      provider: element.getAttribute('data-privider'),
      plans: JSON.parse(element.getAttribute('data-plans')),
      pickupPlaces: JSON.parse(element.getAttribute('data-pickup-places')),
      orderLimits: JSON.parse(element.getAttribute('data-order-limits'))
    };
    ReactDOM.render(<TWP ticket={ticket} />, element);
  });

  Array.from(
    document.querySelectorAll('.js-jep_t-ticket-form')
  ).forEach((element: HTMLDivElement) => {
    const ticket = {
      ticketId: parseInt(element.getAttribute('data-ticket-id')),
      name: element.getAttribute('data-name'),
      provider: element.getAttribute('data-privider'),
      plans: JSON.parse(element.getAttribute('data-plans')),
      pickupPlaces: JSON.parse(element.getAttribute('data-pickup-places')),
      orderLimits: JSON.parse(element.getAttribute('data-order-limits'))
    };
    ReactDOM.render(<JEP_T ticket={ticket} />, element);
  });

  Array.from(
    document.querySelectorAll('.js-jep_nn-ticket-form')
  ).forEach((element: HTMLDivElement) => {
    const ticket = {
      ticketId: parseInt(element.getAttribute('data-ticket-id')),
      name: element.getAttribute('data-name'),
      provider: element.getAttribute('data-privider'),
      plans: JSON.parse(element.getAttribute('data-plans')),
      pickupPlaces: JSON.parse(element.getAttribute('data-pickup-places')),
      orderLimits: JSON.parse(element.getAttribute('data-order-limits'))
    };
    ReactDOM.render(<JEP_NN ticket={ticket} />, element);
  });

  Array.from(document.querySelectorAll('.js-snow-item-price-calculator')).forEach(element => {
    const selectedPeopleCount = JSON.parse(element.getAttribute('data-selected-people-count'));
    const coupons = JSON.parse(element.getAttribute('data-coupons'));
    const isPartnerEc = element.hasAttribute('data-for-partner-ec');
    const itemId = Number(element.getAttribute('data-item-id'));
    const itemName = element.getAttribute('data-item-name');
    const isRangeSelect = false; // レンジは対応しない方針
    const dateDuration = Number(element.getAttribute('data-date-duration')) || 1;
    const price = JSON.parse(element.getAttribute('data-price') || '{}');
    const priceTable = JSON.parse(element.getAttribute('data-price-table') || '{}');
    const maxParticipantsData = element.getAttribute('data-max-participants');
    const limitedTo = element.getAttribute('data-limited-to') as ('adult'|'child'|'student'|'senior');
    const noCart = !!element.getAttribute('data-no-cart');
    const noDate = element.hasAttribute('data-no-date');
    const resortString = element.getAttribute('data-resort');
    const resort = JSON.parse(resortString || '{}');
    const isRequest = element.hasAttribute('data-is-request');
    const localCurrency: ICurrency = JSON.parse(element.getAttribute('data-local-currency'));
    const deadline: IDeadline = JSON.parse(element.getAttribute('data-deadline') || '{}');
    const isKanjiwari = element.hasAttribute('data-kanjiwari');
    const necessaryParticipants = Number(element.getAttribute('data-necessary-participants'));
    const deposit = Number(element.getAttribute('data-deposit'));
    const isCharge = JSON.parse(element.getAttribute('data-is-charge').toLowerCase());
    const seasonPassAttributeValue = element.getAttribute('data-is-seasonpass');
    const isSeasonPass = seasonPassAttributeValue ? JSON.parse(seasonPassAttributeValue.toLowerCase()) : false;
    const forAxess = JSON.parse(element.getAttribute('data-for-axess').toLowerCase());
    const merchantCustomizedSeniorCategoryNameFlag = element.hasAttribute('data-merchant-customized-senior-category-name-flag');
    const merchantCustomizedStudentCategoryNameFlag = element.hasAttribute('data-merchant-customized-student-category-name-flag');
    if (!noDate && priceTable == null) {
      console.error('利用日指定が必須で、価格がない商品です。');
    }
    if (noDate) {
      ReactDOM.render(
        <SnowItemPriceCalculatorNoDate
          itemId={itemId}
          itemName={itemName}
          dateDuration={dateDuration}
          price={price}
          maxParticipants={maxParticipantsData && Number(maxParticipantsData)}
          limitedTo={limitedTo}
          noCart={noCart}
          resort={resort}
          localCurrency={localCurrency}
          deposit={deposit}
          isCharge={isCharge}
          isSeasonPass={isSeasonPass}
          forAxess={forAxess}
          isPartnerEc={isPartnerEc}
          coupons={coupons}
          selectedPeopleCount={selectedPeopleCount}
          merchantCustomizedStudentCategoryNameFlag={merchantCustomizedStudentCategoryNameFlag}
          merchantCustomizedSeniorCategoryNameFlag={merchantCustomizedSeniorCategoryNameFlag}
        />,
        element as HTMLElement
      );
      return;
    }
    if (Object.keys(priceTable).length !== 0) {
      ReactDOM.render(
        <SnowItemPriceCalculator
          itemId={itemId}
          itemName={itemName}
          isRangeSelect={isRangeSelect}
          dateDuration={dateDuration}
          selectedDateList={[]}
          priceTable={priceTable}
          maxParticipants={maxParticipantsData && Number(maxParticipantsData)}
          limitedTo={limitedTo}
          noCart={noCart}
          minDateTime={snowItemMinDateTime({ isRequest, deadline })}
          resort={resort}
          localCurrency={localCurrency}
          isKanjiwari={isKanjiwari}
          necessaryParticipants={necessaryParticipants}
          deposit={deposit}
          isCharge={isCharge}
          forAxess={forAxess}
          isPartnerEc={isPartnerEc}
          coupons={coupons}
          selectedPeopleCount={selectedPeopleCount}
          merchantCustomizedStudentCategoryNameFlag={merchantCustomizedStudentCategoryNameFlag}
          merchantCustomizedSeniorCategoryNameFlag={merchantCustomizedSeniorCategoryNameFlag}
        />,
        element as HTMLElement
      );
      return;
    }
  });

  Array.from(document.querySelectorAll('.js-shopping-cart-alert-success')).forEach(element => {
    ReactDOM.render(
      <AlertSuccess />,
      element as HTMLElement
    );
  });

  Array.from(document.querySelectorAll('.js-shopping-cart-inventory')).forEach(element => {
    let cartItems = null;
    let cartItemsString = null;
    const cartVersion = element.getAttribute('data-cart-version');
    if (localStorage.get('userPutItemsToCartWithoutLoggingIn') === 'true') {
      cartItems = localStorage.get(cartVersion) || '{}';
    } else {
      cartItemsString = element.getAttribute('data-cart-items');
      cartItems = JSON.parse(cartItemsString || '{}');
    }
    const localCurrency: ICurrency = JSON.parse(element.getAttribute('data-local-currency'));
    ReactDOM.render(
      <Inventory
        cartVersion={cartVersion}
        cartItems={cartItems}
        localCurrency={localCurrency}/>,
      element as HTMLElement
    );
  });

  Array.from(document.querySelectorAll('.js-shopping-cart')).forEach(element => {
    const localCurrency :ICurrency = JSON.parse(element.getAttribute('data-local-currency'));
    const newCartItems = JSON.parse(element.getAttribute('data-new-cart-items'));
    const isItemChanged = Boolean(element.getAttribute('data-is-item-changed'));
    ReactDOM.render(
      <div>
        <Cart localCurrency={localCurrency} newCartItems={newCartItems} isItemChanged={isItemChanged} />
      </div>,
      element as HTMLElement
    );
  });

  Array.from(document.querySelectorAll('.js-shopping-cart-accommodation-button')).forEach(element => {
    const yadoName = element.getAttribute('data-yado-name');
    const totalAdultNum = Number(element.getAttribute('data-adult-num'));
    const resortString = element.getAttribute('data-resort');
    ReactDOM.render(
      <YadoCartButton
        yadoName={yadoName}
        totalAdultNum={totalAdultNum}
        resort={JSON.parse(resortString || '{}')}
      />,
      element as HTMLElement
    );
  });

  // 親: .js-field-with-sync data-target="xxx" data-index="1"
  // 子: *[data-field-synced="xxx"]
  // 親のフィールド 1, 2, 3 が半角スペース区切りでマージされて子のフィールドに伝播する
  Array.from(document.querySelectorAll('.js-field-with-sync')).forEach((element: any) => {
    const target: string = element.getAttribute('data-target');
    const mergeTarget: string = element.getAttribute('data-merge-target');
    const mergeIndex: number = Number(element.getAttribute('data-merge-index')); // if not set, 0
    const isMultiple = !!mergeTarget;

    function syncField(event: any): void {
      const currentTarget = event ? event.currentTarget : element;
      // 入力値の半角スペースは無視される
      if (isMultiple) {
        currentTarget.value = currentTarget.value.replace(/\s|　/, '');
      }
      Array.from(document.querySelectorAll(`*[data-field-synced="${target}"]`)).forEach((ele: HTMLInputElement) => {
        ele.value = currentTarget.value;
      });
      Array.from(document.querySelectorAll(`*[data-field-synced="${mergeTarget}"]`)).forEach((ele: HTMLInputElement) => {
        const fieldVal: string[] = ele.value.split(' ');
        fieldVal[mergeIndex] = currentTarget.value;
        ele.value = fieldVal.join(' ')
      });
    }

    element.addEventListener('change', syncField);
    element.addEventListener('keyup', syncField);

    // ブラウザバックしても前の値を保持する
    window.addEventListener('load', () => syncField({ currentTarget: element }));
  });

  // 宿のキャンセルポリシーを動的に取得するコンポーネント
  // 既存の宿実装からは独立している
  Array.from(document.querySelectorAll('.js-shopping-cart-yado-cancellation-policy')).forEach(element => {
    const host = element.getAttribute('data-host');
    const params = element.getAttribute('data-params');
    ReactDOM.render(
      <YadoCancellationPolicy
        host={host}
        params={JSON.parse(params || '{}')}
      />,
      element as HTMLElement
    );
  });

  // レッスンの検索UI
  Array.from(document.querySelectorAll('.js-lesson-search')).forEach(element => {
    const lessons = element.getAttribute('data-lessons');
    const localCurrency: ICurrency = JSON.parse(element.getAttribute('data-local-currency'));
    ReactDOM.render(
      <LessonSearch lessons={JSON.parse(lessons || '{}')} localCurrency={localCurrency} />,
      element as HTMLElement
    );
  });
});
